const L = (v) => (Array.isArray(v) ? v.filter(Boolean) : []);

const Sec = ({ title, children }) => <section className="resumeSection"><h2>{title}</h2>{children}</section>;

export const ResumeDocument = ({ r }) => (
  <article className="resumeDocument" data-testid="studio-resume-preview">
    <header><h1>{r.name}</h1>{r.headline && <h2>{r.headline}</h2>}<p>{L(r.contact).join("  |  ")}</p></header>
    {r.summary && <Sec title="Professional Summary"><p>{r.summary}</p></Sec>}
    {L(r.skills).length > 0 && <Sec title={r.skills_heading || "Skills"}>
      <div className="skillGrid">{r.skills.map((s) => <div key={s.category}><h4>{s.category}</h4><p>{s.items}</p></div>)}</div></Sec>}
    {L(r.experience).length > 0 && <Sec title="Professional Experience">{r.experience.map((e, i) => (
      <div className="resumeEntry" key={i}>
        <div className="entryHead"><h3>{e.title}<span>{e.company ? ` · ${e.company}` : ""}</span></h3><small>{e.dates}</small></div>
        {e.location && <em>{e.location}</em>}
        <ul>{L(e.bullets).map((b, j) => <li key={j}>{b}</li>)}</ul>
      </div>))}</Sec>}
    {L(r.projects).length > 0 && <Sec title="Projects">{r.projects.map((p, i) => (
      <div className="resumeEntry" key={i}>
        <div className="entryHead"><h3>{p.name}</h3><small>{p.dates}</small></div>{p.stack && <em>{p.stack}</em>}
        <ul>{L(p.bullets).map((b, j) => <li key={j}>{b}</li>)}</ul>
      </div>))}</Sec>}
    {L(r.education).length > 0 && <Sec title="Education">{r.education.map((e, i) => (
      <div className="educationRow" key={i}><strong>{e.degree}</strong><span>{[e.institution, e.location, e.dates].filter(Boolean).join(" · ")}</span></div>))}</Sec>}
    {L(r.certifications).length > 0 && <Sec title="Certifications"><ul>{r.certifications.map((c) => <li key={c}>{c}</li>)}</ul></Sec>}
  </article>
);

const Chips = ({ items, tone, testId }) => (
  <div data-testid={testId} style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
    {L(items).map((k) => <span key={k} style={{ background: tone, padding: "4px 9px", fontSize: 12, fontWeight: 700 }}>{k}</span>)}
  </div>
);

export const ChangeLog = ({ cl = {} }) => (
  <aside data-testid="studio-change-log" style={{ display: "grid", gap: 16 }}>
    <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
      {[["ATS estimate before", cl.ats_before, "#fff0ed"], ["ATS estimate after", cl.ats_after, "#e8f5ef"]].map(([l, v, bg]) => (
        <div key={l} style={{ background: bg, padding: "14px 18px", flex: "1 1 160px" }} data-testid={`studio-${l.includes("after") ? "ats-after" : "ats-before"}`}>
          <small style={{ fontSize: 11, fontWeight: 800, letterSpacing: ".08em", textTransform: "uppercase" }}>{l}</small>
          <strong style={{ display: "block", font: "700 34px/1.1 Georgia" }}>{v ?? "—"}<small style={{ fontSize: 14 }}>/100</small></strong>
        </div>))}
    </div>
    {L(cl.verify).length > 0 && <div className="warningBanner" data-testid="studio-verify"><b>Verify before you send</b><ul>{cl.verify.map((v) => <li key={v}>{v}</li>)}</ul></div>}
    {L(cl.changes).length > 0 && <div><b>What changed and why</b><ul style={{ margin: "8px 0 0", paddingLeft: 18, fontSize: 14, lineHeight: 1.55 }}>{cl.changes.map((c) => <li key={c}>{c}</li>)}</ul></div>}
    {L(cl.keywords_matched).length > 0 && <div><b>Keywords now backed by evidence</b><Chips items={cl.keywords_matched} tone="#e8f5ef" testId="studio-keywords-matched" /></div>}
    {L(cl.keywords_missing).length > 0 && <div><b>Keywords you have no evidence for yet</b><Chips items={cl.keywords_missing} tone="#fff4e8" testId="studio-keywords-missing" />
      <p style={{ fontSize: 12, color: "#657068", marginTop: 6 }}>Only add these if you can prove them in an interview.</p></div>}
    {cl.gap_analysis && <div><b>Honest fit note</b><p style={{ fontSize: 14, marginTop: 6 }}>{cl.gap_analysis}</p></div>}
    {cl.linkedin_headline && <div><b>Suggested LinkedIn headline</b><p style={{ fontSize: 14, marginTop: 6, background: "#edf4f2", padding: 10 }} data-testid="studio-linkedin-headline">{cl.linkedin_headline}</p></div>}
  </aside>
);
